<template>
  <rkm-modal
    :loading="loading"
    ref="Modal"
    title="Relatório de cadastros consistentes - Lista de Pacientes"
    extraLarge
  >
    <template>
      <rkm-area title="Filtros da busca" type="fieldset" no-margin-top>
        <rkm-row>
          <rkm-col>
            Unidade
            <rkm-alert color="secondary">
              <strong> {{ filtros.unidade }} </strong>
            </rkm-alert>
          </rkm-col>
          <rkm-col cols="auto">
            Domicílio
            <rkm-alert color="secondary">
              <strong> {{ filtros.domicilio }} </strong>
            </rkm-alert>
          </rkm-col>
          <rkm-col cols="auto">
            Área / INE
            <rkm-alert color="secondary">
              <strong> {{ filtros.areaIne }} </strong>
            </rkm-alert>
          </rkm-col>
          <rkm-col cols="auto">
            Microárea
            <rkm-alert color="secondary">
              <strong> {{ filtros.microarea }} </strong>
            </rkm-alert>
          </rkm-col>
        </rkm-row>
      </rkm-area>

      <rkm-area no-margin-top title="Resultado">
        <template v-slot:trailing>
          <rkm-button
            :disabled="items.length === 0"
            @click="exportTo"
            color="info"
            small
            title="Exportar"
          >
            <rkm-icon icon="file-export" />
          </rkm-button>
        </template>

        <rkm-table :fields="fields" :items="items">
          <template #thead-top>
            <rkm-tr>
              <rkm-th :colspan="fields.length" class="text-center"
                >Pacientes</rkm-th
              >
            </rkm-tr>
          </template>
          <template v-slot:cell(dataNascimento)="row">
            {{ row.value | formatDate }}
          </template>
        </rkm-table>
      </rkm-area>
    </template>

    <template #footer>
      <rkm-button :disabled="!!loading" @click="cancel"> Fechar </rkm-button>
    </template>
  </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters, mapActions } from "vuex";

// Mixins
import { repository, data, object, stringCase, file } from "@/mixins";

// Filters.
import formats from "@/filters/formats";

export default {
  computed: {
    ...mapGetters({ loading: "getLoading" }),
  },
  created() {
    this.repositories = {
      exportacao: this.getConectaSusRepository("exportacao.atencaoBasica"),
    };
  },
  data: () => ({
    items: [],
    fields: [
      {
        key: "nome",
        label: "Nome",
        sortable: true,
        fixed: true,
      },
      {
        key: "dataNascimento",
        label: "Data de Nascimento",
        sortable: true,
        fixed: true,
      },
      {
        key: "prontuario",
        label: "Prontuário",
        sortable: true,
        fixed: true,
      },
    ],
    filtros: {
        unidade: '',
        domicilio: '',
        areaIne: '',
        microarea: '',
    },
    pacientes: null,
    pacienteIds: null,
  }),
  filters: {
    formatDate: formats.formatDate,
  },
  methods: {
    ...mapActions(["setLoading", "unsetLoading"]),
    open(filtros, pacientes, pacienteIds) {

      this.filtros = filtros;
      this.items = pacientes;
      this.pacienteIds = JSON.stringify(pacienteIds);
      this.$refs.Modal.show();
    },
    cancel() {
      this.$refs.Modal.hide();
    },
    exportTo() {
      this.setLoading();
      this.repositories.exportacao
        .relatorioCadastroConsistentePaciente({
            unidade: this.filtros.unidade,
            domicilio: this.filtros.domicilio,
            area: this.filtros.areaIne,
            microarea: this.filtros.microarea,
            pacientes: this.pacienteIds,
            selectedCols: this.prepareDataWithColumns()
        })
        .then(({ data, headers }) =>
          this.openFile(data, headers["content-type"])
        )
        .catch(this.handleError)
        .finally(() => this.unsetLoading());
    },
    prepareDataWithColumns() {
      return this.fields.map((f) => {
        return {
          key: this.camelToSnake(f.key),
          label: f.label,
          class: f.class,
        };
      });
    },
  },
  mixins: [data, object, stringCase, file, repository],
};
</script>